import type { KeyboardEvent } from 'react';
import { css } from '@terra/ui-styled-system';

export const applicationDocsFileUploadRootClassName = css({
  position: 'relative',
  minHeight: 0,
  '& [data-part=hidden-input], & input[type=file]': {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
  },
});

export const applicationDocsCompactFileUploadTriggerClassName = css({
  display: 'flex',
  w: 'full',
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: 'sm',
  fontWeight: 'normal',
  color: 'fg.muted',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.default',
  borderRadius: 'md',
  bg: 'bg.default',
  px: 3,
  py: '7px',
  cursor: 'pointer',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 0.6,
  },
});

export const applicationDocsChooseFilesLabelClassName = css({
  cursor: 'pointer',
  fontWeight: 'normal',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 0.6,
    pointerEvents: 'none',
  },
  _focusVisible: {
    outline: '2px solid',
    outlineColor: 'border.outline',
    outlineOffset: '2px',
  },
});

export const activateFileUploadLabelOnKeyDown = (
  event: KeyboardEvent<HTMLLabelElement>,
) => {
  if (event.key !== 'Enter' && event.key !== ' ') {
    return;
  }

  event.preventDefault();
  event.currentTarget.click();
};
